import {Component, Input, ViewChild, ElementRef, EventEmitter, Output} from "@angular/core";
import {faChevronDown, faChevronUp, IconDefinition} from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'collapsible-with-checkbox',
    template: `
        <ng-container *ngIf="hasChildNodes">
            <input *ngIf="hasCheckbox" type="checkbox" [id]="idCheckbox" class="line big-Check-box"
                   [checked]="isChecked"
                   [name]="nameCheckbox"
                   (input)="checkAll($event)">
            <div class="flex title-wrapper line" (click)="open = !open">
                <h3 class="title">{{ title }}</h3>
                <fa-icon [icon]="up" *ngIf="open"></fa-icon>
                <fa-icon [icon]="down" *ngIf="!open"></fa-icon>
            </div>

            <div #content [hidden]="!open">
                <ng-content></ng-content>
            </div>
        </ng-container>
    `,
    styles: [`
        .title-wrapper {
            align-items: baseline;
            cursor: pointer;
        }

        .title {
            margin-right: 20px;
            top: -3px;
            position: relative;
        }

        .line {
            display: inline-flex;
        }

        .big-Check-box {
            width: 18px;
            height: 18px;
        }
    `]
})
export class CollapsibleWithCheckboxComponent {
    @Input()
    public title: string;

    @Input()
    public open: boolean;

    @Input()
    public hasCheckbox: boolean;

    @Input()
    public idCheckbox: string;

    @Input()
    public nameCheckbox: string;

    @Input()
    public isChecked: boolean;

    @Output()
    public readonly onCheckAll: EventEmitter<boolean> = new EventEmitter();

    public down: IconDefinition = faChevronDown;
    public up: IconDefinition = faChevronUp;

    /** Check if element has child to display or not the content */
    @ViewChild('content')
    public set content(content: ElementRef) {
        if (content) this.hasChildNodes = content.nativeElement.childElementCount > 0;
    };

    // Keep this variable "true" by default
    public hasChildNodes: boolean = true;

    public checkAll(event: any): void {
        this.onCheckAll.emit(event.target.checked);
    }
}
